import { pairingTypes } from "src/modules/pairing/constants";

export default function resolveText({
  pairingType,
  familyName,
  responderFamilyName,
  t,
  deviceName,
  didLogIn,
  didSignUp
}) {
  let successType;
  let value0;
  let value1;
  switch (pairingType) {
    case pairingTypes.INITIAL:
      if (didSignUp) {
        value0 = familyName;
        successType = "createdAccount";
      } else if (didLogIn) {
        value0 = deviceName;
        successType = "addedToFamily";
      } else {
        successType = "initial";
      }
      break;
    case pairingTypes.OUR_FAMILY_CREATE:
      if (didLogIn) {
        value0 = deviceName;
        successType = "addedToFamily";
      } else {
        value0 = familyName;
        successType = "createdFamily";
      }
      break;
    case pairingTypes.OUR_FAMILY:
      value0 = deviceName;
      successType = "addedToFamily";
      break;
    case pairingTypes.THEIR_FAMILY:
    case pairingTypes.THEIR_FAMILY_CREATE:
      value0 = responderFamilyName;
      successType = "joinedFamily";
      break;
    case pairingTypes.DEVICES:
      value0 = deviceName;
      value1 = responderFamilyName ? ` (${responderFamilyName})` : "";
      successType = "devicesOnly";
      break;
    default:
      successType = pairingType;
      break;
  }

  return t(`pairing.success.text.${successType}`, {
    value0,
    value1
  });
}
